export const removeHtmlTags = (str: string): string => {
  // Matches any tag that is not a <b> or </b> tag
  return str.replace(/<(?!\/?b\b)[^>]*>/gm, '')
}
